// ============================================================
// ExceptionalFire — Custom Search Overlay
// Uses Shopify Predictive Search API
// ============================================================
(function() {
  'use strict';

  var overlay = document.getElementById('ef-search-overlay');
  // Move overlay to body root so it escapes all stacking contexts
  if (overlay && overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }
  var input = document.getElementById('ef-so-input');
  var emptyState = document.getElementById('ef-so-empty');
  var resultsState = document.getElementById('ef-so-results');
  var noResultsState = document.getElementById('ef-so-noresults');
  var loadingState = document.getElementById('ef-so-loading');
  var productsContainer = document.getElementById('ef-so-products');
  var suggestionsContainer = document.getElementById('ef-so-suggestions');
  var collectionsContainer = document.getElementById('ef-so-collections');
  var collectionsLabel = document.getElementById('ef-so-collections-label');
  var viewAllLink = document.getElementById('ef-so-viewall');
  var noQuerySpan = document.getElementById('ef-so-noquery');

  if (!overlay || !input) return;

  var debounceTimer = null;
  var abortController = null;
  var DEBOUNCE_MS = 250;
  var PRODUCTS_LIMIT = 6;

  // ── Open / Close (with body scroll lock) ──
  var savedScrollY = 0;
  function lockBody() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }
  function unlockBody() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, savedScrollY);
  }
  function openSearch() {
    overlay.setAttribute('aria-hidden', 'false');
    /* 2026-05-07 — toggle inert in sync with aria-hidden so children are
       focusable when overlay open + removed from tab order when closed. */
    overlay.removeAttribute('inert');
    lockBody();
    setTimeout(function() { input.focus(); }, 100);
    showState('empty');
  }

  function closeSearch() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('inert', '');
    input.value = '';
    showState('empty');
    if (abortController) abortController.abort();
    unlockBody();
  }

  window.efSearchOpen = openSearch;
  window.efSearchClose = closeSearch;

  // Close on click outside the search container
  var container = overlay.querySelector('.ef-so__container');
  overlay.addEventListener('mousedown', function(e) {
    if (container && !container.contains(e.target)) {
      closeSearch();
    }
  });
  overlay.querySelector('.ef-so__backdrop').addEventListener('mousedown', closeSearch);
  overlay.querySelector('.ef-so__close').addEventListener('click', closeSearch);

  // Close on Escape — listen on document so it works regardless of focus
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
      e.preventDefault();
      closeSearch();
    }
  });

  // ── State management ──
  function showState(state) {
    emptyState.style.display = state === 'empty' ? '' : 'none';
    resultsState.style.display = state === 'results' ? '' : 'none';
    noResultsState.style.display = state === 'noresults' ? '' : 'none';
    loadingState.style.display = state === 'loading' ? '' : 'none';
  }

  // ── Input handler ──
  input.addEventListener('input', function() {
    var query = input.value.trim();
    if (query.length < 2) {
      showState('empty');
      if (abortController) abortController.abort();
      return;
    }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() { doSearch(query); }, DEBOUNCE_MS);
  });

  // ── Search API call ──
  function doSearch(query) {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    showState('loading');

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,query' +
      '&resources[limit]=' + PRODUCTS_LIMIT +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=hide';

    fetch(url, { signal: abortController.signal })
      .then(function(r) { return r.json(); })
      .then(function(data) { renderResults(data, query); })
      .catch(function(err) {
        if (err.name !== 'AbortError') {
          showState('noresults');
          noQuerySpan.textContent = query;
        }
      });
  }

  // ── Render results ──
  function renderResults(data, query) {
    var resources = data.resources && data.resources.results;
    if (!resources) { showState('noresults'); noQuerySpan.textContent = query; return; }

    var products = resources.products || [];
    var collections = resources.collections || [];
    var queries = resources.queries || [];

    if (products.length === 0 && queries.length === 0 && collections.length === 0) {
      showState('noresults');
      noQuerySpan.textContent = query;
      return;
    }

    // Products
    productsContainer.innerHTML = '';
    products.forEach(function(p) {
      var img = p.image || (p.featured_image && p.featured_image.url) || '';
      var price = formatMoney(p.price);
      var compareAt = p.compare_at_price_max && p.compare_at_price_max > p.price ? formatMoney(p.compare_at_price_max) : '';
      var type = getProductType(p);

      var card = document.createElement('a');
      card.href = p.url;
      card.className = 'ef-so__product';
      card.innerHTML =
        '<img class="ef-so__product-img" src="' + resizeImage(img, '112x112') + '" alt="" loading="lazy">' +
        '<div class="ef-so__product-info">' +
          '<div class="ef-so__product-title">' + escapeHtml(p.title) + '</div>' +
          '<div class="ef-so__product-meta">' +
            '<span class="ef-so__product-price">' + price + '</span>' +
            (compareAt ? '<span class="ef-so__product-compare">' + compareAt + '</span>' : '') +
          '</div>' +
          (type ? '<div class="ef-so__product-type">' + type + '</div>' : '') +
        '</div>';
      productsContainer.appendChild(card);
    });

    // View all link
    if (products.length > 0) {
      viewAllLink.href = '/search?q=' + encodeURIComponent(query);
      viewAllLink.style.display = '';
    } else {
      viewAllLink.style.display = 'none';
    }

    // Suggestions
    suggestionsContainer.innerHTML = '';
    queries.forEach(function(q) {
      var a = document.createElement('a');
      a.href = '/search?q=' + encodeURIComponent(q.text);
      a.className = 'ef-so__suggest-link';
      a.innerHTML = highlightMatch(q.text, query);
      suggestionsContainer.appendChild(a);
    });

    // Collections
    collectionsContainer.innerHTML = '';
    if (collections.length > 0) {
      collectionsLabel.hidden = false;
      collections.forEach(function(c) {
        var a = document.createElement('a');
        a.href = c.url;
        a.className = 'ef-so__coll-link';
        a.textContent = c.title;
        collectionsContainer.appendChild(a);
      });
    } else {
      collectionsLabel.hidden = true;
    }

    showState('results');
  }

  // ── Helpers ──
  function formatMoney(value) {
    if (!value && value !== 0) return '';
    // Shopify suggest API returns price as string like "865.00" (dollars, not cents)
    var num = parseFloat(value);
    if (isNaN(num)) return '';
    return '$' + num.toFixed(num % 1 === 0 ? 0 : 2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function resizeImage(url, size) {
    if (!url) return '';
    // Shopify image URL resize
    if (url.indexOf('cdn.shopify.com') !== -1) {
      return url.replace(/(\.[a-z]+)(\?|$)/, '_' + size + '$1$2');
    }
    return url;
  }

  function getProductType(product) {
    // Detect product type from tags or product_type
    var type = (product.product_type || '').toLowerCase();
    var tags = (product.tags || []).join(',').toLowerCase();
    if (tags.indexOf('cfg-custom') > -1 || tags.indexOf('cfg-standard') > -1) return 'Configurable';
    if (type.indexOf('door') > -1) return 'Fireplace Door';
    if (type.indexOf('screen') > -1) return 'Screen';
    if (type.indexOf('mantel') > -1) return 'Mantel';
    return '';
  }

  function highlightMatch(text, query) {
    var idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return escapeHtml(text);
    return escapeHtml(text.substring(0, idx)) +
      '<mark>' + escapeHtml(text.substring(idx, idx + query.length)) + '</mark>' +
      escapeHtml(text.substring(idx + query.length));
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

})();
